// Every colour, line and tab colour of the Excel report, the same on every sheet - the design in Designforslag_Week43
// (Documentation/excel-report). ARGB, as ExcelJS writes them.

/** The header of each category of columns (cellStyle.js says which columns). */
export const GROUP_FILLS = {
  identity: 'FF4B3F72',
  people: 'FF6B4F2C',
  info: 'FF2E5E3E',
  planner: 'FFD9D9D9',
  setup: 'FF8C6D1F',
  applications: 'FF1F3A6B',
  assessments: 'FF2E75B6',
  finish: 'FF595959',
};

/** What each category is, as the Colors sheet says it. */
export const GROUP_LABELS = {
  identity: 'Identity – who and which trial (CO, CustomerNo, Protocol, Trial)',
  people: 'People (SD, PI, FT)',
  info: 'Trial info – describes the trial (target, host, address, crop, type, treatments, plots, soil sample, country, GPS)',
  planner: 'The planner\'s own columns (prod, papir, person) – filled in by hand',
  setup: 'Set-up tasks (Reserved area, Stacked out, Borders sprayed, Plot size)',
  applications: 'Applications A–L',
  assessments: 'Assessments V00–V14',
  finish: 'Finish (Harvest, Pegs up, Destruction)',
};

/** A header's text: white, but black on the planner's light grey. */
export const HEADER_FONT = 'FFFFFFFF';
export const PLANNER_HEADER_FONT = 'FF000000';

/** A task cell by its status (cellStatus.js): fill, text colour, and struck through for Cancelled. */
export const STATUS_COLOURS = {
  done: { fill: 'FFE2F0D9', font: 'FF006100' },
  planned: { fill: 'FFDDEBF7', font: 'FF1F4E78' },
  interval: { fill: 'FFFFFFFF', font: 'FF404040' },
  overdue: { fill: 'FFFFC7CE', font: 'FF9C0006' },
  missing: { fill: 'FFFFF2CC', font: 'FF9C5700' },
  'not-needed': { fill: 'FFEDEDED', font: 'FF808080' },
  cancelled: { fill: 'FFEDEDED', font: 'FF808080', strike: true },
};

/** The rows' shade, white and light grey in turn for each new CO (not each row). */
export const ROW_SHADES = ['FFFFFFFF', 'FFF2F2F2'];
/** A task column without a task: a shade lighter than its row's. */
export const NO_TASK_SHADES = ['FFFFFFFF', 'FFF7F7F7'];
/** The planner's columns (prod, papir, person): always white, to write in. */
export const PLANNER_FILL = 'FFFFFFFF';

/** Every data cell: a thin light grey grid. */
export const GRID_BORDER = { style: 'thin', color: { argb: 'FFD9D9D9' } };
/** Between header cells: thin white; under the header row: medium dark grey. */
export const HEADER_SIDE_BORDER = { style: 'thin', color: { argb: 'FFFFFFFF' } };
export const HEADER_BOTTOM_BORDER = { style: 'medium', color: { argb: 'FF404040' } };
/** Left of the first column of a new category, header included. */
export const CATEGORY_BORDER = { style: 'medium', color: { argb: 'FF7F7F7F' } };
/** Above the first row of a new CO. */
export const CO_BORDER = { style: 'medium', color: { argb: 'FF404040' } };
/** The sheet's next task (work sheets): a black frame, and bold text. */
export const NEXT_TASK_BORDER = { style: 'medium', color: { argb: 'FF000000' } };
/** The customer's script's red rule (scriptRedRule): a red frame over the cell's status colour. */
export const WARNING_BORDER = { style: 'medium', color: { argb: 'FFFF0000' } };

/** Each sheet's tab. */
export const TAB_COLOURS = {
  'All data': 'FF4B3F72',
  'Set-Up': 'FF8C6D1F',
  Borderspray: 'FF8C6D1F',
  Application: 'FF1F3A6B',
  Assessment: 'FF2E75B6',
  Soil_Sample: 'FF8C6D1F',
  Pegup: 'FF595959',
  Harvest: 'FF595959',
  Colors: 'FFBFBFBF',
};
/** The layout sheet's tab (its name is the layout's): the trial info category's green. */
export const LAYOUT_TAB_COLOUR = 'FF2E5E3E';

/**
 * The legend row under a work sheet's data, as in the Week 43 template (row 25 / 55): the planners' 9 person colours,
 * without text, from column C - each { cells, colour } (an ExcelJS colour: argb, or a theme colour with its tint).
 */
export const PERSON_COLOURS = [
  { cells: 1, colour: { argb: 'FF00B050' } },
  { cells: 2, colour: { theme: 3, tint: 0.3999755851924192 } },
  { cells: 3, colour: { theme: 3, tint: 0.7999816888943144 } },
  { cells: 2, colour: { theme: 5, tint: 0.3999755851924192 } },
  { cells: 2, colour: { theme: 7, tint: 0.3999755851924192 } },
  { cells: 2, colour: { theme: 8, tint: 0.3999755851924192 } },
  { cells: 2, colour: { theme: 2, tint: -0.249977111117893 } },
  { cells: 2, colour: { argb: 'FFFF0000' } },
  { cells: 1, colour: { theme: 9, tint: 0.3999755851924192 } },
];
